import React, { useState } from 'react'
import HotelBanner from './HotelBanner'
import Tours from './Tours'
import SeeBeautiful from './SeeBeautiful'
import ExcitementSeeking from './ExcitementSeeking'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import FamilyTopAttractions from './FamilyTopAttractions'
import Winery from './Winery'
import FineDining from './FineDining'
import { Helmet } from 'react-helmet-async'
import hotelrentbg from '../../../assets/images/hotel-hero-bg.png'
import Favorite from '../../../assets/images/Favorite-bg1.png'

export default function HotelIndex() {
    const place = useSelector((state) => state.place);
    const pageTitle = place
        ? `${place} Hotels | Best Deals, Attractions & Tours`
        : `Hotels & Travel Deals | Explore Top Destinations`;

    const pageDescription = place
        ? `Explore top hotels, attractions, tours, wineries, fine dining and travel deals in ${place}. Discover traveler favorites worth booking.`
        : `Explore top hotels, tours, wineries, fine dining and unforgettable travel experiences. Discover traveler favorites worth booking.`;
    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>

                <meta name="description" content={pageDescription} />

                {/* Open Graph for social preview */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={hotelrentbg} />

                {/* Optional: Keywords */}
                <meta
                    name="keywords"
                    content="hotels, tours, travel deals, attractions, fine dining, wineries, best places to visit"
                />
            </Helmet>

            <HotelBanner />
            <SeeBeautiful />
            <ExcitementSeeking />
            <section className="section-equal-padding favorite-section uk-scrollspy-inview"
                style={{ backgroundImage: `url(${Favorite})` }}
                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                <div className="container d-flex justify-content-center text-center">
                    <div className="favorite-block uk-scrollspy-inview"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                        <h2 className="mb-4">Traveler Favorites: <br />Deals Worth Booking</h2>
                        <p>Discover the most loved travel deals, handpicked by explorers like you. These top-rated escapes
                            combine unbeatable value with unforgettable experiences from stunning beach resorts to thrilling
                            city adventures. </p>
                        <Link to={place ? '/deals/:sub' : '/deals'} className="white-btn mt-3">View Deals</Link>
                    </div>
                </div>
            </section>
            <Tours />
            
            <Winery />
            <FamilyTopAttractions />
            <FineDining />
        </>
    )
}
